// extracted by mini-css-extract-plugin
export default {"icon-input":"icon-input_icon-input__JRa6l","spin":"icon-input_spin__1tfnb"};